// extracted by mini-css-extract-plugin
module.exports = {"boxOnlyDetails":"HAM_boxOnlyDetails__11daO"};